<template>
  <div>
    <b-row>
      <b-col>
        <h1>{{ headline }}</h1>
        <h2>{{ subheadline }}</h2>
        <p class="intro">Quis ex, nihil soluta.</p>
        <p class="body">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Qui adipisci, sunt facilis laudantium beatae atque odio dolorem reiciendis sint, ab rerum consequatur fugit similique ducimus maiores. Quis ex, nihil soluta.</p>
        <ul>
          <li>Lorem ipsum dolor</li>
          <li>Lorem ipsum dolor</li>
          <li>Lorem ipsum dolor</li>
          <li>Lorem ipsum dolor</li>
          <li>Lorem ipsum dolor</li>
        </ul>
        <p class="caption">Quis ex, nihil soluta.</p>
        <hr>
        <button class="btn solid">Button Solid</button>&nbsp;
        <button class="btn solid disabled">Button Disabled</button>&nbsp;
        <button class="btn solid small">Button Small</button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  export default {
    // Using a couple of props for no real reason at all.
    name: 'Intro',
    props: {
      headline: String,
      subheadline: String,
    }
  }
</script>


<style>
  
</style>
